export default __webpack_public_path__ + "static/media/12-32-15.bd969065.jpg";